import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getImageUrl } from "src/Common/common";
import { handleError } from "src/Common/function";
import { setTicketNumber } from "src/Redux/Slices/HeaderSlice";
import { setNewMessageNotification } from "src/Redux/Slices/TicketSlice";
import TicketService from "src/Services/API/ticket.service";
import TicketMessageService from "src/Services/API/ticketmessage.service";
import InfoSection from "./components/InfoSection";
import MarkAsClosedButton from "./components/MarkAsClosedButton";
import ReopenButton from "./components/ReopenButton";
import ChatSection from "./components/ChatSection";
import UserService from "src/Services/API/user.service";
import { useSelector } from "react-redux";

const TicketDetail = () => {
  const currentUser = UserService.getCurrentUser();
  const { ticketId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ticket, setTicket] = useState(location.state?.ticket || null);
  const [isClosing, setIsClosing] = useState(false);
  const [isReopening, setIsReopening] = useState(false);

  const newMessageNotification = useSelector((state) => state.Ticket.newMessageNotification);

  const fetchTicket = async () => {
    // if (!ticket?.id) return;
    try {
      const response = await TicketService.getOne(ticketId);
      setTicket(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  useEffect(() => {
    if (newMessageNotification) {
      fetchTicket();
      dispatch(setNewMessageNotification(false));
    }
  }, [newMessageNotification]);

  useEffect(() => {
    console.log("🚀 ~ TicketDetail ~ ticketId:", ticketId)
    if (ticketId) {
      fetchTicket();
    }
  }, [ticketId]);

  useEffect(() => {
    if (ticket?.number) {
      dispatch(setTicketNumber(String(ticket.number)));
    }
  }, [ticket]);

  const handleSendNote = async (noteText, attachments = []) => {

    if (!ticket?.id) return;

    try {
      const response = await TicketMessageService.createMessage({
        message: noteText,
        ticketId: ticket.id,
        senderUserId: currentUser.id
      });

      const savedMessage = response.data;
      const messageId = savedMessage?.id;

      if (attachments.length && messageId) {
        await TicketMessageService.uploadAttachments(attachments, messageId);
      }
      await fetchTicket();
    } catch (error) {
      handleError(error);
    }
  };

  const handleCloseTicket = async () => {
    if (!ticket?.id || isClosing || ticket?.status === 100) return;
    try {
      setIsClosing(true);
      await TicketService.update({
        id: ticket.id,
        status: 100,
      });
      setTicket((prev) => (prev ? { ...prev, status: 100 } : prev));
      await fetchTicket();
    } catch (error) {
      handleError(error);
    } finally {
      setIsClosing(false);
    }
  };

  const handleReopenTicket = async () => {
    if (!ticket?.id || isReopening || ticket?.status !== 100) return;
    try {
      setIsReopening(true);
      await TicketService.update({
        id: ticket.id,
        status: 0,
      });
      setTicket((prev) => (prev ? { ...prev, status: 0 } : prev));
      await fetchTicket();
    } catch (error) {
      handleError(error);
    } finally {
      setIsReopening(false);
    }
  };

  return (
    <div className="w-full px-5 py-4">
      <div className="w-full h-[56px] flex items-center justify-between">
        <div className="flex items-center cursor-pointer" onClick={() => navigate(-1)}>
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
        <div className="flex items-center">
          {ticket?.status === 100 ? (
            <ReopenButton
              isReopening={isReopening}
              onReopen={handleReopenTicket}
              status={ticket?.status}
            />
          ) : (
            <MarkAsClosedButton
              isClosing={isClosing}
              onClose={handleCloseTicket}
              status={ticket?.status}
            />
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 xl:grid-cols-2">
        <InfoSection ticket={ticket} />

        <div className="flex flex-col gap-4">
          <ChatSection notes={ticket?.messages} onSend={handleSendNote} />

          {/* <div className="border border-borderColor rounded-md">
            <div className="border-b border-borderColor px-4 py-3">
              <span className="font-OpenSansRegular font-[700] text-[14px] text-titleColor">History</span>
            </div>
            <div className="min-h-[160px] px-4 py-4" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TicketDetail;